import React, { useEffect, useMemo } from 'react';

import { useOnceReveal } from '@common/hooks';
import { PdpProductSizeType } from '@domains/pdp-common';

import { OthersSizeView } from '../components/OthersSizeView';
import { useSizeRecommendationUBL } from '../log/useSizeRecommendationUBL';
import { useOthersSizeService } from '../services/useOthersSizeService';

export const OthersSizeContainer = () => {
  const { myFigureText, handleInfoClick, recommendOptionValueList } = useOthersSizeService();
  const { otherSizeImpressionUBL } = useSizeRecommendationUBL();
  const { targetRef, isRevealed } = useOnceReveal();

  // UBL 데이터 생성
  const ublParams = useMemo(
    () => ({
      recommendation_type: PdpProductSizeType.OPTION,
      option_value_list: recommendOptionValueList.map((option: { ranking: number; name: string }) => ({
        ranking: option.ranking,
        name: option.name,
      })),
    }),
    [recommendOptionValueList],
  );

  // 다른 체형이 구매했어요 노출 로그
  useEffect(() => {
    if (isRevealed && myFigureText) {
      otherSizeImpressionUBL(ublParams);
    }
  }, [isRevealed, myFigureText, otherSizeImpressionUBL, ublParams]);

  return (
    <div ref={targetRef}>
      <OthersSizeView
        myFigureText={myFigureText}
        recommendOptionValueList={recommendOptionValueList}
        onInfoClick={handleInfoClick}
      />
    </div>
  );
};
